import {useState} from 'react';
import moment, {Moment} from 'moment';
import {ButtonV2} from '../../system/ButtonV2/ButtonV2';
import {MenuItemContainer} from '../../system/menu';
import css from './ExportV2.module.css';
import {CSVFeatureDescription} from '../../system/FeatureDescriptionModal';
import {PremiumWrapper} from '../PremiumWrapper';

export const ExportV2 = () => {
  const [from, setFromDate] = useState(format(moment()));
  const [to, setToDate] = useState(format(moment()));
  const [downloadEnabled, setDownloadEnabled] = useState(false);
  return (
    <MenuItemContainer title={'Export Heart Rate to CSV'}>
      <h2 style={{borderBottom: '1px solid #eee'}}>
        Export to CSV <CSVFeatureDescription />
      </h2>
      <PremiumWrapper
        bi={{from: 'export'}}
        onPremiumChange={(isPremium) => {
          setDownloadEnabled(isPremium);
        }}
      >
        <></>
      </PremiumWrapper>
      <div className={css.column}>
        <div className={css.row}>
          <label>From</label>
          <input
            className={css.datePicker}
            type="datetime-local"
            min={format(parse(to).subtract(30, 'd'))}
            max={to}
            value={from}
            onChange={(event) => {
              setFromDate(event.target.value);
            }}
          />
        </div>
        <div className={css.row}>
          <label>To </label>
          <input
            className={css.datePicker}
            max={format(moment.min([parse(from).add(30, 'd'), moment()]))}
            min={from}
            type="datetime-local"
            value={to}
            onChange={(event) => {
              setToDate(event.target.value);
            }}
          />
        </div>
      </div>
      <ButtonV2
        disabled={!downloadEnabled}
        onClick={() => {
          const fromUTCAsString = parse(from).toISOString();
          const toUTCAsString = parse(to).toISOString();
          const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          let csvUrl = `/csv2?from=${fromUTCAsString}&to=${toUTCAsString}&timeZone=${timeZone}`;
          window.location = csvUrl;
        }}
      >
        Download CSV
      </ButtonV2>
    </MenuItemContainer>
  );
};

function format(m: Moment): string {
  return m.format(moment.HTML5_FMT.DATETIME_LOCAL);
}

function parse(localDateTime: string): Moment {
  return moment(localDateTime, moment.HTML5_FMT.DATETIME_LOCAL).utc();
}
